import React from "react";
import { Box, makeStyles, MenuItem, TextField } from "@material-ui/core";


let useStyles = makeStyles((theme) => ({
    root: {
        width: "270px",
        height: 50,
        margin: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down("950")]: {
            minWidth: '48%',
        },
        [theme.breakpoints.down("700")]: {
            width: '100%',
        },
    },
    box: {
        margin: 0,
    }
}))

export default function Index({ state, handleChange }) {

    let classes = useStyles();

    const packingOptions = [
        { value: '1', label: 'پالت چوبی' },
        { value: '2', label: 'پالت فلزی' },
        { value: '3', label: 'فله' },
        { value: '4', label: 'کیسه' },
        { value: '5', label: 'جامبوبگ' },
        { value: '6', label: 'کپسول 60' },
        { value: '7', label: 'کپسول 90' },
        { value: '8', label: 'کپسول 120' },
        { value: '9', label: 'شمش' },
        { value: '10', label: 'عدل' },
        { value: '11', label: 'شاخه' },
        { value: '12', label: 'بشکه' },
        { value: '13', label: 'لیتر' },
        { value: '14', label: 'کلاف' },
        { value: '15', label: 'رول' },
        { value: '16', label: 'کارتن' },
        { value: '17', label: 'سایر' },
        { value: '18', label: 'پالت پلاستیکی' },
        { value: '19', label: 'بیتوپلاست' },
        { value: '20', label: 'بیتوپک' },
    ];

    const sortedOptions = packingOptions.sort((a, b) => a.label.localeCompare(b.label, 'fa'));

    return (
        <div className={classes['root']}>
            <Box
                className={classes['box']}
                width="100%"
                height="50px"
            >
                <TextField
                    id="standard-select-currency"
                    select
                    value={state?.packaging_type_id ? state?.packaging_type_id : ''}
                    onChange={(event) => handleChange(+event.target.value, "packaging_type_id")}
                    helperText=""
                    size="small"
                    fullWidth
                    variant="outlined"
                    label={'بسته بندی'}
                >
                    {sortedOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                    <MenuItem value="">همه</MenuItem>
                    {/* <MenuItem value="1">پالت چوبی</MenuItem>
                    <MenuItem value="2">پالت فلزی</MenuItem>
                    <MenuItem value="3">فله</MenuItem>
                    <MenuItem value="4">کیسه</MenuItem>
                    <MenuItem value="5">جامبوبگ</MenuItem>
                    <MenuItem value="6">کپسول 60</MenuItem>
                    <MenuItem value="7">کپسول 90</MenuItem>
                    <MenuItem value="8">کپسول 120</MenuItem>
                    <MenuItem value="9">شمش</MenuItem>
                    <MenuItem value="10">عدل</MenuItem>
                    <MenuItem value="11">شاخه</MenuItem>
                    <MenuItem value="12">بشکه</MenuItem>
                    <MenuItem value="13">لیتر</MenuItem>
                    <MenuItem value="14">کلاف</MenuItem>
                    <MenuItem value="15">رول</MenuItem>
                    <MenuItem value="16">کارتن</MenuItem>
                    <MenuItem value="17">سایر</MenuItem>
                    <MenuItem value="18">پالت پلاستیکی</MenuItem>
                    <MenuItem value="19">بیتوپلاست</MenuItem>
                    <MenuItem value="20">بیتوپک</MenuItem>
                    <MenuItem value="">همه</MenuItem> */}
                </TextField>
            </Box>
        </div>)
}
